export default __webpack_public_path__ + "static/media/mapbox-token-create.a39b3271.png";